<template>
  <section>
    <EditDialog :orgId="orgId" ref="editDialog" @sub="handleEditSub" />
    <span class="primary cur" @click="showEdit()">添加</span>
    <!-- 表格 -->
    <section class="tableBox" v-show="resultVal.length !== 0">
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="resultVal"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        />
        <!-- 常规列表项 end -->
        <!-- 操作按钮 -->
        <el-table-column prop="control" label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <section>
              <!-- 操作按钮 -->
              <qx-permpisions permpisions="">
                <span class="primary cur" @click="showEdit(scope.row)">修改</span>
              </qx-permpisions>
              <qx-permpisions permpisions="">
                <span class="primary cur" @click="del(scope.row)">删除</span>
              </qx-permpisions>
              <!-- 操作按钮 end -->
            </section>
          </template>
        </el-table-column>
        <!-- 操按钮 end -->
      </el-table>
    </section>
    <!-- 表格 end -->
  </section>
</template>

<script>
import EditDialog from './editDialog';
export default {
  components: {
    EditDialog,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    resultVal: {
      type: Array,
      default: () => ([]),
    },
    orgId: {
      default: '',
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'payAmt',
            label: '申请金额',
          },
          {
            prop: 'userName',
            label: '司机姓名',
          },
          {
            prop: 'mobilePhone',
            label: '司机手机',
          },
          {
            prop: 'orderId',
            label: '订单号码',
          },
        ],
        // data: [ // 表格内容
        // ],
      },
    };
  },
  methods: {
    showEdit (item) {
      this.$refs.editDialog.show(item);
    },
    handleEditSub ({form, originData}) {
      if (originData) {
        const index = this.resultVal.indexOf(originData);
        this.resultVal.splice(index, 1, form);
      } else {
        this.resultVal.push(form);
      }
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
    del (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
  },
};
</script>

<style>

</style>
